import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getCharacter({params}) {
  // console.log('call api getCharacter', params);
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_CHARACTER, {params})
    );

    yield put(actionCreators.getCharacterSuccess(response.data.data));

  } catch (error) {
    
  }
}

function* characterModels() {
  yield takeLatest(actionTypes.GET_CHARACTER_REQUEST, getCharacter);
}

export default characterModels;
